import CoverOverlay from './CoverOverlay.view';

export default CoverOverlay;
